/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconWifi1 = createReactComponent("wifi-1", "IconWifi1", [
  ["path", { d: "M12 18l.01 0", key: "svg-0" }],
  ["path", { d: "M9.172 15.172a4 4 0 0 1 5.656 0", key: "svg-1" }]
]);

export { IconWifi1 as default };
//# sourceMappingURL=IconWifi1.js.map
